import React from 'react';

import './CustomProgressBar.css';

const CustomProgressBar = props => {
  return (
    <div className="progress__overlay">
        <div className="pMessage">{props.message}</div>
      {props.children}
    </div>
  );
};

export default CustomProgressBar;